import { IFormGeneratorSchemaType } from "@/types/form-generator-schema-type";
import { FORM_INPUTS } from "@/types/form-inputs";
import { SelectOptionItem } from "@/types/select-option";

export type ImageFormSchemaFields = "image" | "title" | "publisherId";

export type IImageFormSchema = Record<ImageFormSchemaFields, IFormGeneratorSchemaType>;

export const createImageSchema = (publisherOptions: SelectOptionItem[]): IImageFormSchema => ({
    image: {
        label: "Image",
        placeholder: "(Max Size: 3Mb)",
        type: FORM_INPUTS.IMAGE,
        props: {
            required: true,
            accept: "image/*",
        },
    },
    title: {
        label: "Title",
        placeholder: "Title",
        type: FORM_INPUTS.TEXT,
        props: {
            required: true,
        },
    },
    publisherId: {
        label: "Publisher",
        placeholder: "Select Publisher",
        type: FORM_INPUTS.SELECT,
        data: publisherOptions,
        defaultValue: 0,
        props: {
            required: true,
        },
    },
});
